import React from 'react';
import _ from 'lodash';
import api from '../../../services/seguridadProvider';
import { Avatar, Dropdown, Menu, message } from 'antd';
import { NavLink } from 'react-router-dom';
import { IResponse } from '../../../interfaces/response';

const accountItems = [
  { id: 0, text: 'Editar cuenta', icon: 'icofont-ui-home', route: '/vertical/edit-account' },
  // { text: 'User profile', icon: 'icofont-ui-user', route: '/vertical/user-profile' },
  // { text: 'Calendar', icon: 'icofont-ui-calendar', route: '/vertical/events-calendar' },
  { id: 1, text: 'Configuración', icon: 'icofont-ui-settings', route: '/vertical/settings' },
  { id: 2, text: 'Salir', icon: 'icofont-logout', route: '/public/sign-in' }
];

const SettingsDropdown = () => {
  const cerrar = async (item) => {
    const val = _.find(accountItems, { 'text': item.currentTarget.text });
    if (val.id === 2) {
      // const res: IResponse<number> = await api.logout();
      // if (res.succeeded) {
      //   message.info(res.message);
      //   localStorage.removeItem('token');
      // }
    }
  };

  const accountMenu = (
    <Menu style={{ minWidth: '180px' }}>
      {accountItems.map((item, index) => (
        <Menu.Item className='action-item' key={index}>
          <NavLink className='d-flex w-100' onClick={cerrar} to={item.route} replace>
            <span className={`icon mr-3 ${item.icon}`} />
            <span className='text'>{item.text}</span>
          </NavLink>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={accountMenu} trigger={['click']} placement='bottomRight'>
      <div className='item'>
        <Avatar
          size={40}
          className='mr-1'
          src={`${window.location.origin}/content/user-40-1.jpg`}
        />
        <span className='icofont-simple-down' />
      </div>
    </Dropdown>
  );
};

export default SettingsDropdown;
